export function FooterSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative py-12 sm:py-16 md:py-20 bg-black/50 backdrop-blur-sm border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center space-y-8 sm:space-y-12">
          {/* Logo Section */}
          <div className="relative">
            <h2 className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-extralight text-white tracking-[0.15em] sm:tracking-[0.2em] md:tracking-[0.3em] mb-6 sm:mb-8">DEEPQUEST</h2>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-48 sm:w-72 md:w-96 h-1 bg-gradient-to-r from-transparent via-violet-400 to-transparent"></div>
          </div>

          {/* Social Media Icons */}
          <div className="flex justify-center gap-4 sm:gap-6">
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 transition-all duration-300 cursor-pointer">
              <i className="ri-twitter-x-line text-lg sm:text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 transition-all duration-300 cursor-pointer">
              <i className="ri-linkedin-line text-lg sm:text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 transition-all duration-300 cursor-pointer">
              <i className="ri-instagram-line text-lg sm:text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 transition-all duration-300 cursor-pointer">
              <i className="ri-discord-line text-lg sm:text-xl"></i>
            </a>
          </div>

          {/* Copyright and Links */}
          <div className="pt-6 sm:pt-8 border-t border-white/10">
            <p className="text-gray-500 text-xs sm:text-sm px-4">
              © 2024 DeepQuest. All rights reserved.
              <span className="block sm:inline mt-2 sm:mt-0">
                <a href="#" className="sm:ml-4 hover:text-white transition-colors duration-300 cursor-pointer">Privacy Policy</a>
                <a href="#" className="ml-4 hover:text-white transition-colors duration-300 cursor-pointer">Terms of Service</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}